var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SankeyChart"},[_c('div',{style:({width: '550px', height: '180px'}),attrs:{"id":"sankeychart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }